<template>
  <Layout>
    <div class="termo-pagina mt-4">
      <nav class="termo-trilha" aria-label="Você está em">
        <button type="button" class="termo-trilha-link" @click="voltarAoPainel">
          <i class="ri-home-4-line"></i><span>Início</span>
        </button>
        <i class="ri-arrow-right-s-line termo-trilha-sep" aria-hidden="true"></i>
        <span class="termo-trilha-atual">Meus termos</span>
      </nav>

      <TermosSection />

      <div class="termo-rodape">
        <BButton variant="light" @click="voltarAoPainel">
          <i class="ri-arrow-left-line align-bottom me-1"></i> Voltar ao início
        </BButton>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main.vue";
import TermosSection from "@/views/mirai/dashboard/components/TermosSection.vue";

/**
 * Página dedicada aos termos.
 *
 * O conteúdo é o mesmo componente que aparece como seção no painel — a rota
 * existe para o link do e-mail de notificação continuar funcionando e para quem
 * salva o endereço nos favoritos. Duplicar a tela renderizaria duas versões
 * para manter, e foi exatamente o que deixou esta página destoando do resto.
 */
export default {
  name: "termo-index",
  components: { Layout, TermosSection },
  methods: {
    voltarAoPainel() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.termo-pagina {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.termo-trilha {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.82rem;
  color: #64748b;
}

.termo-trilha-link {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.25rem 0.5rem;
  border: 0;
  border-radius: 0.5rem;
  background: transparent;
  color: #1d4ed8;
  font-weight: 600;
}

.termo-trilha-link:hover {
  background: rgba(37, 99, 235, 0.1);
}

.termo-trilha-sep {
  color: #94a3b8;
}

.termo-trilha-atual {
  font-weight: 600;
  color: var(--vz-body-color, #0f172a);
}

.termo-rodape {
  display: flex;
  justify-content: flex-start;
}

[data-bs-theme="dark"] .termo-trilha,
[data-layout-mode="dark"] .termo-trilha {
  color: #94a3b8;
}

[data-bs-theme="dark"] .termo-trilha-link,
[data-layout-mode="dark"] .termo-trilha-link {
  color: #7dd3fc;
}

[data-bs-theme="dark"] .termo-trilha-atual,
[data-layout-mode="dark"] .termo-trilha-atual {
  color: #e2e8f0;
}
</style>
